var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsertEmoticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99175 1.66675C5.39175 1.66675 1.66675 5.40008 1.66675 10.0001C1.66675 14.6001 5.39175 18.3334 9.99175 18.3334C14.6001 18.3334 18.3334 14.6001 18.3334 10.0001C18.3334 5.40008 14.6001 1.66675 9.99175 1.66675ZM10.0001 16.6667C6.31675 16.6667 3.33341 13.6834 3.33341 10.0001C3.33341 6.31675 6.31675 3.33341 10.0001 3.33341C13.6834 3.33341 16.6667 6.31675 16.6667 10.0001C16.6667 13.6834 13.6834 16.6667 10.0001 16.6667ZM12.9167 9.16675C13.6084 9.16675 14.1667 8.60842 14.1667 7.91675C14.1667 7.22508 13.6084 6.66675 12.9167 6.66675C12.2251 6.66675 11.6667 7.22508 11.6667 7.91675C11.6667 8.60842 12.2251 9.16675 12.9167 9.16675ZM7.08342 9.16675C7.77508 9.16675 8.33342 8.60842 8.33342 7.91675C8.33342 7.22508 7.77508 6.66675 7.08342 6.66675C6.39175 6.66675 5.83342 7.22508 5.83342 7.91675C5.83342 8.60842 6.39175 9.16675 7.08342 9.16675ZM10.0001 14.5834C11.9417 14.5834 13.5917 13.3667 14.2584 11.6667H5.74175C6.40841 13.3667 8.05841 14.5834 10.0001 14.5834Z",
    fill: "#1C1C1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertEmoticon);
export default __webpack_public_path__ + "static/media/insert-emoticon.69d091f6fe015d772ab505aa1822f7db.svg";
export { ForwardRef as ReactComponent };